import React, { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import filterIcon from "./../../../assets/icons/filter 1.png";
import searchIcon from "./../../../assets/icons/searchIcon 1.png";
import bin from "./../../../assets/icons/recycle-binColor.png";
import ediPencil from "./../../../assets/icons/editPencil.png";
import Paper from "@mui/material/Paper";

import CustomDataGrid from "../../components/CustomDataGrid/CustomDataGrid.tsx";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingView from "../../components/LoadingView/LoadingView";
import KeywordTagDialog from "../../product/components/KeywordTagDialog.tsx";
import SweetAlertModal from "../../components/SweetAlertModal/SweetAlertModal";
import arrowUp from "./../../../assets/icons/arrowup.png";
import arrowDown from "./../../../assets/icons/arrowDown.png";
import AddFoodcategoryDialog from "./AddFoodCategoryDialog.tsx";

const FoodCategory = () => {
  const apiAddress = process.env.REACT_APP_SECRET;
  const [Loading, setLoading] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const onDialogClose = (props) => {
    setOpen(props);
    setOpenEditFoodCategory(props);
  };

  const [OpenEditFoodCategory, setOpenEditFoodCategory] = useState(false);
  const [EditFoodCategory, setEditFoodCategory] = useState();
  const onEditClick = (props) => {
    console.log(props);

    setEditFoodCategory(props);
    setOpenEditFoodCategory(true);
  };
  const columnsdatas = [
    {
      field: "title",
      headerName: "Food Category",
      renderCell: (params) => (
        <div className="d-flex " style={{ gap: "10px" }}>
          <span
            // onClick={() => { setsectionItemsToggle(true); setsectionItemsdialogType(params.value) }}
            style={{ color: "blue", cursor: "pointer" }}
          >
            {params.value}
          </span>
          <div
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => {
              onEditClick(params.row);
            }}
          >
            <img src={ediPencil} alt="" style={{ width: "1rem" }} />
          </div>
        </div>
      ),
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
  ];
  const [dataRows, setDataRows] = useState([]);
  const [dataRowsCollection, setdataRowsCollection] = useState([]);

  const loadKeywordTag = () => {
    axios
      .get(apiAddress + "/api/FoodCategory/getAllFoodCategories")
      .then((response) => {
        console.log(response.data);

        setDataRows(response.data);
      });
  };
  useEffect(() => {
    loadKeywordTag();
  }, []);
  const [selectedDataRows, setSelectedDatarows] = useState([]);
  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };

  const deleteBin = () => {
    axios
      .put(apiAddress + "/api/Keyword/DeleteKeywordTag", selectedDataRows)
      .then((response) => {
        console.log(response.data);
        toast.success("Suuccesfully deleted", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        loadKeywordTag();
      });
    setopenConfirmaitonModal(false);
  };

  const errorToast = (msg) => {
    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const reloadData = () => {
    loadKeywordTag();
  };
  return (
    <div>
      <ToastContainer></ToastContainer>
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"You want to delete this?"}
        open={openConfirmaitonModal}
        onyes={deleteBin}
        close={() => {
          setopenConfirmaitonModal(false);
        }}
      />
      <LoadingView
        open={Loading}
        close={() => {
          setLoading(false);
        }}
      />

      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        mt={2}
        mb={2}
      >
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Button
                color="primary"
                size="medium"
                variant="contained"
                style={{ borderRadius: "50%", minWidth: "auto" }}
                onClick={handleClickOpen}
              >
                +
              </Button>
            </Grid>
            <Grid item>
              <img src={filterIcon} alt="" style={{ width: "1rem" }} />
            </Grid>
            <Grid item>Add Filter</Grid>

            <Grid item>
              <div className="roundedCorner">
                <img
                  src={bin}
                  alt=""
                  style={{ width: "1rem" }}
                  onClick={() => {
                    selectedDataRows.length == 0
                      ? errorToast("Please select a Tag")
                      : setopenConfirmaitonModal(true);
                  }}
                />
              </div>
            </Grid>
            <Grid item></Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container flexDirection={"column"} alignItems={"center"}>
            <Grid item>
              <img src={searchIcon} alt="" style={{ width: "1rem" }} />
            </Grid>
            <Grid item>Search</Grid>
          </Grid>
        </Grid>
      </Grid>

      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        {dataRows.length > 0 ? (
          <CustomDataGrid
            columns={columnsdatas}
            dataRows={dataRows}
            getselectedData={getselectedData}
            isLoading={Loading}
          />
        ) : (
          "No Data found"
        )}
      </Paper>
      {open ? (
        <AddFoodcategoryDialog
          open={open}
          onHandleKeywordDialog={onDialogClose}
          reloadData={reloadData}
        />
      ) : (
        ""
      )}
      <AddFoodcategoryDialog
        open={OpenEditFoodCategory}
        onHandleKeywordDialog={onDialogClose}
        editFoodCategory={EditFoodCategory}
        reloadData={reloadData}
      />
    </div>
  );
};

export default FoodCategory;
